import { useContext } from 'react';
import { SiteContext } from '../context/siteContext';

export function useSite() {
  const value = useContext(SiteContext);
  if (!value) throw new Error('SiteProvider mangler.');
  return value;
}
